import type { ClusterMatrix, RankingRules } from '../../data/schemas';
import { getQuestionResultCopy } from '../../data/questionResultCopy';
import { QUESTION_IDS } from '../../types/ids';
import type { DiagnosticInsight, EvaluationContext } from '../../types/result';
import { getPrimaryClusterForQuestion, getRelatedClustersForQuestion } from './primaryCluster';

/**
 * Ermittelt Stärken (FR-INSIGHT-001): Fragewert = 2 und zugehöriger Cluster mindestens 65 %.
 * Maximal drei Einträge, priorisiert nach fachlicher Bedeutung.
 */
export function detectStrengths(
  context: EvaluationContext,
  matrix: ClusterMatrix,
  rankingRules: RankingRules,
): DiagnosticInsight[] {
  const candidates: DiagnosticInsight[] = [];

  for (const questionId of QUESTION_IDS) {
    const answer = context.answers[questionId];
    if (!answer || answer.score !== rankingRules.strengths.minimumQuestionScore) continue;

    const primaryCluster = getPrimaryClusterForQuestion(questionId, matrix);
    const clusterResult = context.clusters[primaryCluster];
    if (
      !clusterResult ||
      clusterResult.percentage < rankingRules.strengths.minimumClusterPercentage
    ) {
      continue;
    }

    const copy = getQuestionResultCopy(questionId, answer.score);
    candidates.push({
      id: `strength_${questionId}`,
      type: 'strength',
      questionId,
      title: copy.title,
      summary: copy.summary,
      detail: copy.detail,
      importance: copy.defaultImportance,
      sourceQuestionIds: [questionId],
      relatedClusterIds: getRelatedClustersForQuestion(questionId, matrix),
    });
  }

  candidates.sort((a, b) => b.importance - a.importance);
  return candidates.slice(0, rankingRules.strengths.maximumItems);
}
